import { isNonEmptyString } from '@cli-utils/shared.js'

export function isDeletedRailwayProject(value: unknown): boolean {
  if (!value || typeof value !== 'object') return false
  const deletedAt = (value as Record<string, unknown>).deletedAt
  return isNonEmptyString(deletedAt)
}
